import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { MenuCategoryDto, MenuResponseDto } from './dto/api-response-dto';
import { ApiResponseDto } from '../tables/dto/api-response-dto';

@Injectable({
  providedIn: 'root',
})
export class MenuApiService {
  constructor(private http: HttpClient) {}

  getMenu(tableId: number): Observable<MenuResponseDto> {
    const url = `tables/menu/${tableId}`;
    return this.http.get<MenuResponseDto>(url);
  }
}
